import styled from 'styled-components';
import UIProgress from 'UIComponents/progress/UIProgress';
import { LORAX } from 'HubStyleTokens/colors';
export const StyledProgressIndicator = styled.div.withConfig({
  displayName: "ProgressIndicatorstyles__StyledProgressIndicator",
  componentId: "sc-1yqgfuv-0"
})(["transition:all 0.6s ease-in-out;position:fixed;right:0;left:0;top:0;z-index:20;"]);
export const ProgressIndicatorWrapper = styled.div.withConfig({
  displayName: "ProgressIndicatorstyles__ProgressIndicatorWrapper",
  componentId: "sc-1yqgfuv-1"
})(["height:8px;border-radius:0 3px 3px 0;overflow:hidden;> *{margin:0;border-radius:0;}"]);
export const ProgressIndicatorProgress = styled(UIProgress).withConfig({
  displayName: "ProgressIndicatorstyles__ProgressIndicatorProgress",
  componentId: "sc-1yqgfuv-2"
})(["height:8px;border-radius:0;[role='progressbar']{border-radius:0;background:", ";}"], LORAX);